/*
  Add color here
*/

import { createTheme } from '@mui/material/styles'

const rawTheme = createTheme()

const createColor = color => rawTheme.palette.augmentColor({ color: { main: color } })

const palette = {
  primary: {
    main: '#FF6700',
    20: createColor('#F73603'),
    40: createColor('#E78706'),
    60: createColor('#DF5000'),
    80: createColor('#D92400'),
    contrastText: '#FFF',
  },
  primary_20: createColor('#F73603'),
  primary_40: createColor('#E78706'),
  primary_60: createColor('#DF5000'),
  primary_80: createColor('#D92400'),
  secondary: {
    main: '#2AD0A6',
    20: createColor('#179365'),
    30: createColor('#624BEE'),
    40: createColor('#4D31DF'),
    60: createColor('#2E17D3'),
    80: createColor('#2D2D6C'),
  },
  secondary_20: createColor('#179365'),
  secondary_30: createColor('#624BEE'),
  secondary_40: createColor('#4D31DF'),
  secondary_60: createColor('#2E17D3'),
  secondary_80: createColor('#2D2D6C'),
  secondary_100: createColor('#AD00FF'),
  secondary_120: createColor('#3D85F0'),
  secondary_140: createColor('#FBF7DF'),
  neutral: {
    main: '#FFF',
    contrastText: '#000',
  },
  accent: {
    20: createColor('#CA3E80'),
    40: createColor('#B6195D'),
  },
  other: {
    grey: { 20: createColor('#F5F5F5'), 40: createColor('#D9D9D9'), 60: createColor('#B4B4B4') },
    black: createColor('#000000'),
    white: createColor('#FFF'),
  },
  accent_60: createColor('#C050E8'),
  grey_20: createColor('#F5F5F5'),
  grey_40: createColor('#D9D9D9'),
  grey_60: createColor('#B4B4B4'),
  grey_80: createColor('#EAEAF1'),
  white: createColor('#FFF'),
  black: createColor('#000'),
  btn_positive: createColor('#3366FF'),
}

const createMuiTheme = ({ mode = 'light' }) =>
  createTheme({
    palette: {
      ...palette,
      mode,
    },
    components: {
      MuiInputBase: {
        styleOverrides: { root: { '&.Mui-disabled': { background: palette.other.grey[20].main } } },
      },
    },
    typography: { fontFamily: 'Noto Sans', fontSize: 13 },
  })

export default createMuiTheme
